<template>
  <div class="company">
    <!-- 公司资料 -->
    <div class="title">
      <label>公司資料</label>
    </div>
    <div class="company-content">
      <el-form
        ref="forms"
        label-width="180px"
        size="small"
        :model="forms"
        :rules="rules"
      >
        <el-form-item label="公司名稱">
          <div class="company_name">
            {{ forms.companyName }}
          </div>
          <!-- <p class="company_name">{{ forms.companyNameEN }}</p> -->
        </el-form-item>
        <div class="col">
          <el-form-item
            label="公司別名"
            prop="companyAlias"
          >
            <el-input
              v-model="forms.companyAlias"
              placeholder="中文"
              maxlength="40"
              show-word-limit
              class="input_type1"
            />
          </el-form-item>
          <el-form-item prop="companyAliasEN">
            <el-input
              v-model="forms.companyAliasEN"
              placeholder="英文"
              maxlength="80"
              show-word-limit
              class="input_type1 left"
            />
          </el-form-item>
        </div>
        <el-form-item
          label="所屬區域"
          prop="regionCode"
        >
          <el-select
            v-model="forms.regionCode"
            placeholder="請選擇所屬區域"
            class="input_type2"
            @focus="empty"
          >
            <el-option
              v-for="item in regionList"
              :key="item.gscopeCode"
              :label="item.gscopeNameWithCulture"
              :value="item.gscopeCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="所屬地區"
          prop="gscopeCode"
        >
          <el-select
            v-model="forms.gscopeCodes"
            placeholder="請選擇所屬地區"
            multiple
            collapse-tags
            class="input_type2"
            @click="chooseGS"
          >
            <el-option
              v-for="item in gscopeList"
              :key="item.gscopeCode"
              :label="item.gscopeNameWithCulture"
              :value="item.gscopeCode"
            />
          </el-select>
        </el-form-item>
        <div class="col">
          <el-form-item
            label="地址"
            prop="address"
          >
            <el-input
              v-model.trim="forms.address"
              placeholder="請輸入中文地址"
              maxlength="100"
              show-word-limit
              class="input_type1"
            />
          </el-form-item>
          <el-form-item
            prop="addressEN"
            class="errerLeft"
          >
            <el-input
              v-model="forms.addressEN"
              placeholder="請輸入英文地址"
              maxlength="300"
              show-word-limit
              class="input_type1 w300 left1"
            />
          </el-form-item>
        </div>

        <el-form-item
          label="公司電話"
          prop="telephone"
        >
          <el-input
            v-model.trim="forms.telephone"
            type="telephone"
            placeholder="請輸入公司電話"
            maxlength="8"
            class="input_type1 pad_1"
          />
        </el-form-item>
        <el-form-item
          label="電郵："
          prop="email"
        >
          <el-input
            v-model.trim="forms.email"
            placeholder="請輸入公司電郵"
            maxlength="60"
            class="input_type1"
          />
        </el-form-item>
        <el-form-item
          label="公司地產代理牌照"
          prop="companyLicense"
          :rules=" !forms.isAllowCompanyLicenseEmpty ? rules.companyLicense : [{ required: false }]"
        >
          <el-input
            v-model.trim="forms.companyLicense"
            placeholder="請輸入公司地產代理牌照"
            maxlength="40"
            show-word-limit
            class="input_type1"
          />
        </el-form-item>
        <el-form-item
          ref="imgClear"
          label="公司標誌"
          prop="logo"
        >
          <!-- 图片上传 -->
          <div class="updata">
            <el-button
              size="small"
              type="primary"
              class="up_btn"
              @click="openAvatarDialog"
            >
              上傳圖片
            </el-button>
            <!-- 上传头像组件2 -->
            <el-dialog
              v-loading="loadingAvatar"
              :title="titleAvatar"
              :visible.sync="openAvatar"
              width="480px"
            >
              <div slot="default">
                <companyimg @getFileData="synchronizeAvatar" />
              </div>
              <span
                slot="footer"
                class="dialog-footer"
              >
                <el-button @click="closeAvatarDialog">取 消</el-button>
                <el-button
                  type="primary"
                  @click="uploadAvatar"
                >確認</el-button>
              </span>
            </el-dialog>
            <!-- <el-upload
              :action="imgUrl"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
              :on-success="imgSuccess"
              class="msg"
            >
              <el-button
                size="small"
                type="primary"
                class="up_btn"
              >上傳圖片</el-button>
            </el-upload> -->
            <!-- <span>
              （圖片大小：600像素(闊) X 400像素(高)，支援格式：JPG, JPEG,
              PNG）
            </span> -->
          </div>
          <img
            :src="pub.imgResize(forms.logo, 'company')"
            class="img"
            alt
          >
        </el-form-item>
        <div class="col">
          <el-form-item
            label="公司簡介"
            prop="introduce"
          >
            <el-input
              v-model="forms.introduce"
              type="textarea"
              placeholder="中文"
              maxlength="300"
              show-word-limit
              class="input_type3 w_93"
            />
            <div>(不多於300字)</div>
          </el-form-item>
          <el-form-item
            prop="introduceEN"
            label-width="-5%"
          >
            <el-input
              v-model="forms.introduceEN"
              type="textarea"
              placeholder="英文"
              maxlength="500"
              show-word-limit
              class="input_type3  w_88"
            />
            <div>(不多於500字)</div>
          </el-form-item>
        </div>
        <div class="col">
          <el-form-item
            label="主要專營地區"
            prop="monopolyArea"
          >
            <el-input
              v-model="forms.monopolyArea"
              type="textarea"
              placeholder="中文"
              maxlength="300"
              show-word-limit
              class="input_type3 w_93"
            />
            <div>(不多於300字)</div>
          </el-form-item>
          <el-form-item
            prop="monopolyAreaEN"
            label-width="-5%"
          >
            <el-input
              v-model="forms.monopolyAreaEN"
              type="textarea"
              placeholder="英文"
              maxlength="500"
              show-word-limit
              class="input_type3 w_88"
            />
            <div>(不多於500字)</div>
          </el-form-item>
        </div>

        <el-form-item
          label="公司網址"
          prop="web"
        >
          <el-input
            v-model="forms.web"
            type="text"
            placeholder="請輸入公司網址"
            maxlength="50"
            class="input_type4"
          />
        </el-form-item>
                
        <el-form-item
          v-if="showWatermark"
          label="水印功能"
          prop="watermark"
        >
          <div class="box_type">
            <el-checkbox v-model="forms.watermark">
              啟用
            </el-checkbox>&nbsp;&nbsp;
            <span class="box_txt">啟用後，刊登樓盤時上傳的所有圖片會加上公司名稱</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="button"
            @click="store('forms')"
          >
            儲存
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- <el-button class="button" @click="cancel('forms')">取消</el-button> -->
  </div>
</template>

<script>
import companyimg from '@/components/AvatarCropper/companyimg';
export default {
    components: {
        companyimg
    },
    data() {
        // 公司电话验证
        const checkTelephone = (rule, value, callback) => {
            let reTele = /^[2-9]\d{7}$/;
            if (!value) {
                return callback(new Error('請輸入公司電話'));
            } 
                if (!reTele.test(value)) {
                    return callback(new Error('請輸入正確公司電話'));
                } 
                    return callback();
                
            
        };
        //英文地址验证
        const checkAddressEN = (rule, value, callback) => {
            let readdress = /^\s+|\s+$/g;
            if (!value) {
                return callback(new Error('請輸入英文地址'));
            } 
                if (readdress.test(value)) {
                    return callback(new Error('請輸入正確英文地址'));
                } 
                    return callback();
                
            
        };
        const checkGscopeCode = (rule, value, callback) => {
            if ((this.forms.gscopeCodes === '' || this.forms.gscopeCodes.length == 0) && this.open) {
                callback(new Error('請選擇所屬地區'));
            } else {
                callback();
            }
        };
        return {
            showWatermark:false,
            open: '',
            labelPosition: 'right',
            titleAvatar: '上傳頭像',
            openAvatar: false,
            loadingAvatar: false,
            // 區塊信息
            regionList: [],
            gscopeList: [],
            forms: {
                companyID: '',
                regionCode: '',
                gscopeCodes: [],
                companyName: '',
                companyNameEN: '',
                address: '',
                addressEN: '',
                telephone: '',
                email:'',
                companyLicense: '',
                introduce: '',
                introduceEN: '',
                monopolyArea: '',
                monopolyAreaEN: '',
                watermark: false,
                web: '',
                logo: ''
            },
            imgSize: {
                width: 0,
                height: 0
            },
            // 表单验证
            rules: {
                regionCode: [
                    {
                        required: true,
                        message: '請選擇所屬區域',
                        trigger: 'change'
                    }
                ],
                gscopeCode: [
                    {
                        validator: checkGscopeCode,
                        message: '請選擇所屬地區',
                        trigger: 'change'
                    }
                ],
                address: [
                    {
                        required: true,
                        message: '請輸入中文地址',
                        trigger: ['blur', 'change']
                    }
                ],
                addressEN: [
                    {
                        required: true,
                        validator: checkAddressEN,
                        trigger: ['blur', 'change']
                    }
                ],
                telephone: [
                    {
                        required: true,
                        validator: checkTelephone,
                        trigger: ['blur', 'change']
                    }
                ],
                email:[{
                    type: 'email', //要检验的类型（number，email，date等）
                    message: '請輸入正確的郵箱地址',
                    trigger: ['blur', 'change']
                }],
                companyLicense: [
                    {
                        required: true,
                        message: '請輸入公司地產代理牌照',
                        trigger: ['blur', 'change']
                    }
                ],
                logo: [
                    {
                        required: true,
                        message: '請上傳公司標誌'
                    }
                ]
            }
        };
    },
    computed: {
        // 上传图片地址(无用)
        imgUrl() {
            return this.pub.getApi().Upload;
        }
    },
    watch: {
        'forms.regionCode': {
            deep: true,
            handler: function (val) {
                this.regionList.forEach(item => {
                    if (item.gscopeCode === val) {
                        this.gscopeList = item.children;
                    }
                });
            }
        }
    },
    created() {
        this.searchGscope();
        this.GetCompanyCofig();
        this.GetFullAgentCompany();
    },
    methods: {
        GetCompanyCofig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                this.showWatermark = res.data.result.watermark
            });
        },
        openAvatarDialog() {
            this.openAvatar = true;
            this.loadingAvatar = false;
            // this.fileUrl = null;
            this.fileList = [];
        },
        synchronizeAvatar(data, fileName) {
            this.fileUrl = data;
            this.fileName = fileName;
        },
        closeAvatarDialog() {
            this.openAvatar = false;
        },
        async uploadAvatar() {
            const formdata = new FormData();
            console.log('file', this.fileUrl, this.fileName);
            formdata.append('file', this.fileUrl, this.fileName);
            this.loadingAvatar = true;
            console.log(formdata);
            let res = await this.axios.post(this.pub.getApi().Upload, formdata);
            if (!res.code === 0) {
                this.$message({
                    showClose: true,
                    message: '标志上传失败',
                    type: 'error'
                });
                // this.loadingAvatar = false;

                // let resUpdateAvatar = await this.axios.get(this.pub.getApi().HeadImagePath, { params: { imagePath: res.data.result[0].url } });
                // if (resUpdateAvatar.data.code === 0) {
                //     await this.pub.obtainAndSetUserInfo();
                //     this.$message({ message: '頭像更換成功！', type: 'success', showClose: true, duration: 3000 });
                //     this.openAvatar = false;
                //     this.loadingAvatar = false;
                // } else {
                //     this.loadingAvatar = false;
                //     this.$message({ message: '未成功上傳頭像，請重試！', type: 'error', showClose: true, duration: 3000 });
                // }
            } else {
                console.log(res);
                this.forms.logo = res.data.result[0].url;
                this.openAvatar = false;
                this.loadingAvatar = false;

                // this.$message({ message: '未成功上傳頭像，請重試！', type: 'error', showClose: true, duration: 3000 });
            }
        },
        chooseGS() {
            this.open = true;
        },
        // 上传图片清除验证
        imgSuccess() {
            this.$refs.imgClear.clearValidate();
        },
        // 清空地区
        empty() {
            this.open = false;
            this.forms.gscopeCodes = '';
        },
        // 获取地区
        async searchGscope() {
            const res = await this.axios.get(this.pub.getApi().SearchGscope);
            if (res.data.code === 0 || res.data.result) {
                this.regionList = res.data.result;
            }
        },
        // 获取公司资料
        async GetFullAgentCompany() {
            const res = await this.axios.get(this.pub.getApi().GetFullAgentCompany);
            let { result } = res.data;
            const { data } = await this.axios.get(this.pub.getApi().SearchGscope);
            const list = data.result;
            const effect = list.find(item => {
                return item.children.find(el => {
                    return el.gscopeCode === result.gscopeCodes[0];
                });
            });
            this.forms = result;
            this.gscopeList = effect.children;
            this.$set(this.forms, 'regionCode', effect.gscopeCode);
        },
        // 标志上传
        beforeAvatarUpload(file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = e => {
                var imageData  = e.target.result;
                var image = new Image();
                image.src = imageData ;
                image.onload = async () => {
                    var width = image.width;
                    var height = image.height;
                    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
                    if (!isJPG)
                        {return this.$message({
                            showClose: true,
                            message: '上傳圖片僅支援JPG, JPEG, PNG格式',
                            type: 'error'
                        });}
                    let flag = width > 600 || height > 400;
                    if (flag)
                        {return this.$message({
                            showClose: true,
                            message: '圖片大小：600像素(闊)X400 像素（高）',
                            type: 'error'
                        });}
                    let formData = new FormData();
                    formData.append('file', file);
                    const { data } = await this.axios.post(this.pub.getApi().Upload, formData);
                    if (!data.code === 0 || !data.result.length === 0) {
                        this.$message({
                            showClose: true,
                            message: '标志上传失败',
                            type: 'error'
                        });
                    } else {
                        this.forms.logo = data.result[0].url;
                    }
                };
            };
        },

        // 储存功能
        async store(forms) {
            this.open = true;
            try {
                await this.$refs[forms].validate();
                const { data } = await this.axios.post(this.pub.getApi().UpdateCompanyDetail, this.forms);
                if (!data.code === 0 || !data.result) {
                    this.$message({
                        showClose: true,
                        message: data.message,
                        type: 'error'
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: '储存成功',
                        type: 'success'
                    });
                }
            } catch (err) {
                console.warn('err', err);
            }
        }
        // 取消功能
        // cancel (forms) {
        //   this.$refs[forms].resetFields()
        // }
    }
};
</script>
<style lang="less">
.company {
    text-align: left;
    .el-dialog__headerbtn {
        background-color: rgba(0, 0, 0, 0);
    }
    input::-webkit-input-placeholder,
    textarea::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #444;
        font-family: PingFangSC-Regular, PingFang SC;
    }
    input:-moz-placeholder,
    textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #444;
    }
    input::-moz-placeholder,
    textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #444;
    }
    input:-ms-input-placeholder,
    textarea:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #444;
    }
    .title {
        font-size: 24px;
        padding-bottom: 20px;
    }
    .up_btn,
    button {
        font-size: 16px;
        background-color: #0062ff;
    }
    .company-content {
        width: 100%;
        background-color: #fff;
        padding-top: 36px;
        padding-bottom: 27px;
        border-radius: 10px;
        .box_type {
            height: 30px;
            position: absolute;
            top: 47%;
            margin-top: -15px;
            .box_txt {
                color: #444444;
                font-size: 16px;
            }
            .el-checkbox__label {
                font-size: 16px;
                color: #222222;
            }
        }
        .col {
            display: flex;
            align-content: center;
        }

        .input_type1 {
            width: 220px;
            input {
                padding-right:54px;
                height: 46px;
                background-color: #fafafb;
                border-radius: 15px;
            }
        }
        .w300{
            width:300px;
        }
        .pad_1{
            padding-right:0;
        }
        .left {
            margin-left: -75%;
        }
        .left1 {
            margin-left: -55%;
        }

        .input_type2 {
            input {
                width: 150px;
                height: 46px;
                background-color: #fafafb;
                border-radius: 15px;
            }
        }
        .input_type3 {
            /deep/.el-textarea__inner {
                font-family: 'Microsoft YaHei', 'Microsoft JhengHei', 'SimSun', Arial, Helvetica, sans-serif;
                color: #000;
            }
            textarea {
                width: 400px;
                height: 92px;
                background-color: #fafafb;
                border-radius: 15px;
                resize: none;
            }
            margin-right:85px;
        }
        .w_93{
            width:93%;
        }
        .w_88{
            width:88%;
        }
        .input_type4 {
            input {
                width: 400px;
                height: 46px;
                background-color: #fafafb;
                border-radius: 15px;
                resize: none;
            }
        }
        .updata {
            margin-bottom: 10px;
            .el-button {
                border-radius: 10px;
            }
            .msg {
                float: left;
                line-height: 0;
            }
        }

        .company_name {
            height: 46px;
            line-height: 46px;
        }

        .button {
            width: 140px;
            height: 38px;
            background-color: #0062ff;
            border-radius: 10px;
        }

        .img {
            display: block;
            width: 150px;
            height: 100px;
            border: 1px dashed #ccc;
            text-align: center;
            line-height: 100px;
            overflow: hidden;
        }
        .el-textarea .el-input__count{
            right: 1px;
        }
        .el-form-item__label {
            height: 46px;
            line-height: 46px;
        }
        .errerLeft {
            .el-form-item__error {
                margin-left: -53%;
            }
            .el-input__inner{
                padding-right:61px;
            }
        }
    }
}
</style>
